// jquery.service.ts
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

declare var $: any;

@Injectable({
  providedIn: 'root',
})
export class JQueryService {
  private isBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  showModal(selector: string) {
    if (this.isBrowser && typeof $ !== 'undefined') {
      $(selector).modal('show');
    }
  }

  hideModal(selector: string) {
    console.log(selector,'selectorselector');
    
    if (this.isBrowser && typeof $ !== 'undefined') {
      $(selector).modal('hide');
    }
  }

  // Extend with more jQuery functions as needed
}
